import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, onSearch }) => {
  const { t } = useTranslation();

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <motion.label
      className="flex flex-col min-w-40 h-14 w-full"
      whileFocus={{ scale: 1.02 }}
      transition={{ type: "spring", stiffness: 400, damping: 10 }}
    >
      <div className="flex w-full flex-1 items-stretch rounded-lg h-full bg-gray-100 dark:bg-background-dark-elevated2 border border-transparent dark:border-primary-darkMode hover:bg-gray-200 dark:hover:bg-background-dark-elevated3 transition-colors">
        <div className="text-gray-500 dark:text-gray-400 flex items-center justify-center pl-4 rounded-l-lg border-r-0 bg-transparent">
          <span className="material-symbols-outlined">search</span>
        </div>
        <input
          id="search-query"
          name="searchQuery"
          className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-[#181411] dark:text-white focus:outline-0 focus:ring-0 border-none bg-transparent h-full placeholder:text-gray-500 dark:placeholder:text-gray-400 px-4 rounded-l-none border-l-0 pl-2 text-base font-normal leading-normal"
          placeholder={t('dashboard.search_placeholder')}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
        />
      </div>
    </motion.label>
  );
};

export default SearchBar;